import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable({providedIn: 'root'})
export class TokenGS1Guard implements CanActivate {

    constructor(private router: Router, private _storageService: StorageService) { }

    public async canActivate(route: ActivatedRouteSnapshot) {
        const expectedRole = route.data.expectedRole;
        const expectedTypeCompte = route.data.expectedTypeCompte;
        const unauthorizedActivite = route.data.unauthorizedActivite;
        const token = this._storageService.getGS1Token();
        const tokenAdmin = localStorage.getItem('tokenAdmin');
            const tokenPayload = this._storageService.getSession();
            // get roles (1 to n roles) as a array after unserializing the token
            if (tokenAdmin && tokenAdmin.trim() !== '') {
                return true
            } else {
                this.router.navigate(['/unauthorized']);
                return false;
            }            
    }
}


